// @ts-nocheck
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PipsPageFrame from './PipsPageFrame';
import { Link, Outlet, useNavigate } from 'react-router';
import { animate, motion, useAnimationFrame, useMotionValue, useTransform } from 'motion/react';
import { useLocation } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import { chevrons } from '../../../svg/SVGData';

const paths = ['general', 'mystery'];
type Data = {
    general: { name: string, url: string },
    mystery: { name: string, url: string },
    // prefab: { name: string, url: string }
}
const categoryData: Data | any = {
    'general': {
        name: 'General Varieties',
        url: '/pips/products/general'
    },
    'mystery': {
        name: 'Mystery Dice',
        url: '/pips/products/mystery',
    },
    // 'prefab': {
    //     name: 'Prefab',
    //     url: '/pips/products/mystery'
    // }
}
type Categories = keyof Data;


const MenuItem: React.FC<{ category: Categories }> = ({ category }) => {
    const location = useLocation();
    const terminalRoute = location.pathname.split('/').at(-1);

    return (
        <Link to={categoryData[category].url}>
            <motion.li
                className={`hover:cursor-pointer ` + (terminalRoute === category ? 'font-bold text-neutral-800' : '')}
                initial={{ opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ opacity: 0 }}
                whileHover={{ x: 12 }}
            >
                <p className='px-1 py-1 '>
                    {categoryData[category].name}
                </p>
            </motion.li>
        </Link>
    )
}

interface MenuButtonProps {
    cb: Function
}

const MenuButton: React.FC<MenuButtonProps> = ({ cb }) => {
    const naturalX = useMotionValue(0);
    const modX = useMotionValue(0);
    const x = useTransform(() => naturalX.get() + modX.get())
    const opacity = useMotionValue(0);

    const [hovered, setHovered] = useState(false);

    const totalDuration = 700;
    const beats = useRef(0);
    
    useAnimationFrame((t, dt) => {
        if (hovered) return;
        if ((t - (beats.current * totalDuration) > totalDuration)) {
            beats.current++;
            animate(x, [-4, 18], { duration: .35, ease: 'easeOut' });
            animate(opacity, [0, 1, 0], { duration: .5 });
        }
    })

    useEffect(() => {
        if (hovered) {
            animate(x, 0);
            animate(opacity, 1);
        }
    }, [hovered])

    const handleOnClick = () => {
        cb();
        animate(x, [8, 0],  { duration: .1 })
    }

    return (
        <div 
            className='flex justify-center size-6 hover:cursor-pointer pt-1' onClick={handleOnClick}
            onPointerOver={() => setHovered(true)}
            onPointerLeave={() => setHovered(false)}
        >
            <motion.svg
                layout
                className={'h-full'}
                style={{ x, opacity }}
                viewBox={chevrons.right.viewbox}
                whileHover={{ scale: 1.05 }}
            >
                <path
                    fill='black'
                    d={chevrons.right.path}
                />
            </motion.svg>
        </div>
    )
}

const PipsProductsMenu: React.FC = () => {
    const location = useLocation();
    const nav = useNavigate();
    const data = useRef<any>(null);
    
    const terminalPath = location.pathname.split('/').at(-1);
    const [pathCursor, setPathCursor] = useState(() => {
        let i = paths.findIndex((v) => v === terminalPath);
        return i > 0 ? i : 0;
    });
    
    const isWide = useMediaQuery({ minWidth: 640 });
    
    const handleButtonOnClick = useCallback(() => {
        setPathCursor((pathCursor + 1) % paths.length)
    }, [pathCursor])
    
    useEffect(() => {
        let terminalPath = location.pathname.split('/').at(-1);
        if (terminalPath === 'products') {
            nav('general')
            data.current = categoryData['general'];
        } else {
            data.current = categoryData[(terminalPath) || 'general']
        }

    }, [location])

    useEffect(() => {
        nav(paths[pathCursor])
    }, [pathCursor])

    return (
        <div className='absolute top-0 left-0 flex flex-col items-center bg-white rounded-br-md bg-opacity-95 text-nowrap font-sans text-xl text-neutral-700 capitalize shadow-lg'>
            {isWide && (
                <motion.ul
                    layout
                    className='px-4 py-2'

                >
                    {Object.keys(categoryData).map((v: string, i) => <MenuItem key={i} category={v} />)}
                </motion.ul>
            )}
            {!isWide && (
                <div className='flex justify-between px-4 py-2'>
                    <p className='text-neutral-800 font-semibold'>{data.current?.name || ''}</p>
                    <MenuButton cb={handleButtonOnClick} />
                </div>
            )}
        </div>
    )
}

const PipsProducts: React.FC = () => {
    return (
        <PipsPageFrame>
            <Outlet />

            <PipsProductsMenu />
        </PipsPageFrame>
    )
}

export default PipsProducts;